import { render } from "./DashBoardLeads.vue?vue&type=template&id=0843225b"
import script from "./DashBoardLeads.vue?vue&type=script&lang=js"
export * from "./DashBoardLeads.vue?vue&type=script&lang=js"
script.render = render

export default script